import { html } from 'lit';

export const NoteNoShadowIcon = html`
  <svg
    width="60"
    height="72"
    viewBox="0 0 60 72"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.9576 26.8962L38.6423 43.5809C42.5269 38.9268 42.2845 31.993 37.9149 27.6235C33.5454 23.254 26.6117 23.0115 21.9576 26.8962ZM37.1193 45.1038L20.4346 28.4192C16.55 33.0732 16.7924 40.007 21.162 44.3765C25.5315 48.746 32.4652 48.9885 37.1193 45.1038ZM19.639 26.1005C25.1063 20.6332 33.9706 20.6332 39.4379 26.1005C44.9053 31.5678 44.9053 40.4322 39.4379 45.8995C33.9706 51.3668 25.1063 51.3668 19.639 45.8995C14.1716 40.4322 14.1716 31.5678 19.639 26.1005Z"
      fill="currentColor"
      fill-opacity="0.1"
    />
  </svg>
`;

export const NoteShadowSampleIcon = html`
  <svg
    width="60"
    height="72"
    viewBox="0 0 60 72"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="60" height="72" />
    <rect
      x="9.23071"
      y="12.0771"
      width="32.3077"
      height="4.61538"
      rx="2"
      fill="currentColor"
      fill-opacity="0.1"
    />
    <rect
      x="9.23071"
      y="25.8462"
      width="40.6154"
      height="2.76923"
      rx="1.38462"
      fill="currentColor"
      fill-opacity="0.1"
    />
    <rect
      x="9.23071"
      y="35.6152"
      width="40.6154"
      height="2.76923"
      rx="1.38462"
      fill="currentColor"
      fill-opacity="0.1"
    />
    <rect
      x="9.23071"
      y="45.3843"
      width="40.6154"
      height="2.76923"
      rx="1.38462"
      fill="currentColor"
      fill-opacity="0.1"
    />
    <rect
      x="9.23071"
      y="55.1533"
      width="13.8462"
      height="2.76923"
      rx="1.38462"
      fill="currentColor"
      fill-opacity="0.1"
    />
  </svg>
`;
